import React from 'react';
import { FormattedMessage } from 'react-intl';
import Checkbox from '@rio-cloud/rio-uikit/lib/es/Checkbox';

interface CheckboxOption {
    id: string;
    label: string;
}

interface CheckboxGroupProps {
    labelId: string;
    options: CheckboxOption[];
    value?: string | string[];
    onChange: (value: string | string[] | null) => void;
    multiple?: boolean;
}

const CheckboxGroupOTA: React.FC<CheckboxGroupProps> = ({
    labelId,
    options,
    value,
    onChange,
    multiple = false,
}) => {
    const handleChange = (optionId: string) => {
        if (multiple) {
            const currentValue = Array.isArray(value) ? value : [];
            const newValue = !currentValue.includes(optionId)
                ? [...currentValue, optionId]
                : currentValue.filter((v: string) => v !== optionId);
            onChange(newValue);
        } else {
            const newValue = value !== optionId ? optionId : null;
            onChange(newValue);
        }
    };

    const isChecked = (optionId: string) => {
        return multiple
            ? Array.isArray(value) && value.includes(optionId)
            : value === optionId;
    };

    return (
        <div className='form-group'>
            <label className='control-label'>
                <FormattedMessage id={labelId}/>
            </label>
            <div className='display-flex flex-wrap'>
                {options.map((option) => {
                    return (
                        <div key={option.id} className='margin-right-15 margin-bottom-5'>
                            <Checkbox
                                checked={isChecked(option.id)}
                                onChange={() => handleChange(option.id)}
                                label={<FormattedMessage id={option.label}/>}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CheckboxGroupOTA;
